export const APP_NAME = import.meta.env.VITE_APP_NAME || 'Quick Build Con'
export const API_BASE_URL = import.meta.env.DEV
  ? '/api/web/v1'
  : (import.meta.env.VITE_API_BASE_URL || '/api/web/v1')
export const LEGACY_API = import.meta.env.DEV
  ? '/api'
  : (import.meta.env.VITE_LEGACY_API || '/api')

export const PROPERTY_INTENTS = ['Buy', 'Rent', 'Commercial'] as const

export const BOTTOM_NAV = [
  { label: 'Home', href: '/', icon: 'home' },
  { label: 'Search', href: '/properties', icon: 'search' },
  { label: 'Post', href: '/add-property', icon: 'plus', highlight: true },
  { label: 'Leads', href: '/my-inquiries', icon: 'inbox' },
  { label: 'Account', href: '/dashboard', icon: 'user' },
] as const
